import http from './index'

// 获取人员信息
export const getPsnInfo = (data = {}) => {
  return http.post(`/hrssc/portal/psnbase/getPsnInfo`, data)
}

// 获取待办消息条数
export const queryMessageCount = (params = {}) => {
  return http.get(`/hrssc/portal/message/queryMessageCount`)
}

export const queryMessageListByPage = (data = {}) => {
  return http.post(`/hrssc/portal/message/queryMessageListByPage`, data)
}

// 查询密码
export const checkPwd = (data = {}) => {
  return http.post(`/hrssc/portal/plantform/checkPwd`, data)
}

// 修改密码
export const updatePassword = (data = {}) => {
  return http.post(`/hrssc/portal/plantform/updatePwd`, data)
}

// 查询入职天数
export const getDaysNum = (data = {}) => {
  return http.post(`/hrssc/portal/notice/getDaysNum`, data)
}

// 每日一签
export const dailylabel = () => {
  return http.get(`/hrssc/portal/label/dailylabel`)
}

// 员工自助最近浏览
export const iconRecent = (data = null) => {
  return http.post(`/hrssc/portal/icon/iconRecent`, data)
}

// 经理自助最近浏览
export const managerIconRecent = (data = null) => {
  return http.post(`/hrssc/portal/icon/managerIconRecent`, data)
}

// 快捷入口
export const quickdata = (params = null) => {
  return http.get(`/hrssc/admin/link/quickdata`, { params })
}

//
export const autoLoginOA = (data = null) => {
  return http.post(`/hrssc/portal/oalogin/autoLoginOA`, data)
}
//
export const tokenrm = (data = null) => {
  return http.post(`/hrssc/portal/plantform/tokenrm`, data)
}

// 机器人
export const doEncode = (data = null) => {
  return http.post(`/hrssc/portal/psnbase/queryAssets/doEncode`, data)
}

export default {
  getPsnInfo,
  queryMessageCount,
  queryMessageListByPage,
  checkPwd,
  updatePassword,
  getDaysNum,
  dailylabel,
  iconRecent,
  managerIconRecent,
  quickdata,
  autoLoginOA,
  tokenrm,
  doEncode
}



// WEBPACK FOOTER //
// ./src/pages/air-service/apis/home.js